import { QuickLinksManager } from "components/quick_links_manager/quick_links_manager";
import { ArrowLeft } from "feather-icons-react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";

export function QuickLinksManagement() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={() => navigate("/admin/management")}>
          <ArrowLeft size={20} />
          Back to Management
        </button>
        <h1>Quick Links Management</h1>
        <p>Manage the quick links displayed on the client dashboard</p>
      </div>

      <div className={styles.content}>
        <QuickLinksManager />
      </div>
    </div>
  );
}
